import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React from 'react';
import { UIHeading2, UIHeading3, UIText1, useDeviceType } from '@cian/ui-kit';
import cn from 'clsx';
import { FooterQRContactCard } from '../internal';
import styles from './styles.css';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Верхняя секция футера, содержащая контакты
 */
export var FooterTop = function FooterTop(_ref) {
  var phone = _ref.phone,
    email = _ref.email,
    phoneDescription = _ref.phoneDescription,
    actionButton = _ref.actionButton,
    qrContactCards = _ref.qrContactCards,
    onPhoneClick = _ref.onPhoneClick,
    onEmailClick = _ref.onEmailClick;
  var deviceType = useDeviceType();
  var isDesktop = deviceType === 'desktop';
  var ContactComponent = isDesktop ? UIHeading2 : UIHeading3;
  return /*#__PURE__*/_jsxs("section", {
    className: cn(styles['container'], styles[deviceType]),
    children: [/*#__PURE__*/_jsxs("div", {
      className: cn(styles['contacts'], styles[deviceType]),
      children: [!!email && /*#__PURE__*/_jsx("a", {
        className: styles['email-link'],
        href: "mailto:".concat(email),
        onClick: onEmailClick,
        children: /*#__PURE__*/_jsx(ContactComponent, {
          color: "primary_100",
          as: "span",
          children: email
        })
      }), !!phone && /*#__PURE__*/_jsx("a", {
        className: styles['phone-link'],
        href: isDesktop ? undefined : "tel:".concat(phone),
        onClick: onPhoneClick,
        children: /*#__PURE__*/_jsx(ContactComponent, {
          color: "current_color",
          as: "span",
          children: phone
        })
      }), !!phoneDescription && /*#__PURE__*/_jsx(UIText1, {
        whiteSpace: "pre-line",
        children: phoneDescription
      }), actionButton && /*#__PURE__*/_jsx("div", {
        className: styles['action-button'],
        children: actionButton
      })]
    }), qrContactCards && !!qrContactCards.length && /*#__PURE__*/_jsx("div", {
      className: cn(styles['qr-contact-cards'], styles[deviceType]),
      children: qrContactCards.map(function (qrContactCard, index) {
        return /*#__PURE__*/_jsx(FooterQRContactCard, _objectSpread({}, qrContactCard), index);
      })
    })]
  });
};